import type { Language } from '@magicschool/supabase/types';

export const OPENAI_LANGUAGE_CHARACTER_TOKEN_MULTIPLIERS: {
  [languageCode in Language]?: number;
} = {
  // Chinese variants (~8x token density)
  'zh-cn': 0.125,
  'zh-hk': 0.125,
  'zh-tw': 0.125,
  // Japanese (2.6-3x token density)
  ja: 0.35,
  // Korean (2-3x token density)
  ko: 0.4,
  // Right-to-left languages (3-4x token density)
  ar: 0.33,
  he: 0.33,
  // European languages with longer words
  it: 0.625, // 1.6x longer
  bg: 0.38, // 2.6x longer
};
